import { jsx as _jsx } from "react/jsx-runtime";
import { StableOutlet } from '@src/components/StableOutlet';
import { AnimateDirection } from '@src/contexts';
import { AnimateContext } from '@src/contexts/AnimateContextProvider';
import { useUserLocale } from '@src/hooks/useUserLocale';
import { AnimatePresence, motion } from 'framer-motion';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
const WIDTH = 300;
export const AnimateWrapper = () => {
    const location = useLocation();
    const { animate, animateDirection } = useContext(AnimateContext);
    const { locale } = useUserLocale();
    const [initialProp, setInitialProp] = useState(false);
    const [animateProp, setAnimateProp] = useState(false);
    const [exitProp, setExitProp] = useState({});
    useEffect(() => {
        setInitialProp(animate
            ? { x: animateDirection === AnimateDirection.RTL ? WIDTH : -WIDTH, opacity: 0 }
            : false);
        setAnimateProp(animate ? { x: 0, opacity: 1 } : false);
        setExitProp(animate ? { x: animateDirection === AnimateDirection.RTL ? -WIDTH : WIDTH, opacity: 0 } : {});
    }, [animate, animateDirection]);
    return (_jsx(AnimatePresence, { mode: 'wait', children: _jsx(motion.div, { initial: initialProp, animate: animateProp, exit: exitProp, transition: { duration: 0.25 }, className: 'page-content', children: _jsx(StableOutlet, {}) }, `${location.pathname}-${locale}`) }));
};
